const compassFR = {
  compass_nav_home: 'Accueil',
  compass_nav_about: 'À Propos',
  compass_nav_licenses: 'Licences Minières',
  compass_nav_investment: 'Investissement',
  compass_nav_contact: 'Contact',
  compass_nav_cta: 'Devenir Partenaire',

  compass_hero_title: "Valoriser les Richesses\nMinérales de la Mauritanie",
  compass_hero_subtitle: "Exploration avant-gardiste • Exploitation durable • Développement communautaire",
  compass_hero_cta1: 'Explorer Nos Licences',
  compass_hero_cta2: "Opportunités d'Investissement",
  compass_hero_stat1_label: 'Surface Totale de Licences',
  compass_hero_stat2_label: 'Ressources Minérales',
  compass_hero_stat3: '100%',
  compass_hero_stat3_label: 'Détenu par GDSATLAS',
  compass_hero_stat4: 'Normes',
  compass_hero_stat4_label: 'Internationales',

  compass_about_tag: 'Qui Nous Sommes',
  compass_about_title: "Excellence Minière\nAvant-Gardiste en Mauritanie",
  compass_about_p1: "Compass Resources Mauritanie est une entreprise avant-gardiste dédiée à l'exploration et à l'exploitation durable des ressources naturelles en Mauritanie. Fondée par une équipe d'experts chevronnés, nous visons à exploiter le riche potentiel minéral du pays tout en privilégiant la durabilité, l'innovation et le développement communautaire.",
  compass_about_p2: "Notre équipe est activement engagée sur le terrain, conduisant des études géologiques détaillées pour transformer ces opportunités en projets viables et durables répondant aux normes mondiales.",
  compass_about_quote: "Nous détenons plusieurs licences couvrant certaines des ressources les plus recherchées, notamment l'Or, l'Uranium, le Minerai de fer, le Cuivre, le Sable noir et le Quartz.",

  compass_licenses_tag: 'Nos Actifs',
  compass_licenses_title: 'Licences Minières Stratégiques',
  compass_licenses_subtitle: 'Compass Resources détient plusieurs licences couvrant 1 352 km² de terrain hautement prospectif',

  compass_gold_title: "Licence Or",
  compass_gold_badge: '204 km²',
  compass_gold_desc: "La licence aurifère de Compass Resources couvre 204 km² de terrain hautement prospectif. Avec une demande mondiale croissante pour l'or en tant qu'actif financier et matière première industrielle, cette licence présente un énorme potentiel. Nos efforts d'exploration visent à découvrir et développer d'importantes réserves aurifères, contribuant à la croissance économique et aux rendements des investisseurs.",
  compass_gold_cta: "Réserves d'Or à Fort Potentiel",

  compass_uranium_title: "Licence Uranium",
  compass_uranium_badge: '486 km²',
  compass_uranium_desc: "Compass Resources détient une licence stratégique d'exploration uranifère couvrant une vaste superficie de 486 km². Cette région est riche en gisements d'uranium, avec un potentiel significatif pour contribuer à la demande mondiale en énergie propre. Notre focus sur l'uranium s'inscrit dans la transition croissante vers des solutions énergétiques durables, positionnant Compass Resources comme acteur clé de la filière nucléaire.",
  compass_uranium_cta: "Avenir Énergétique Propre",

  compass_quartz_title: "Licence Quartz",
  compass_quartz_badge: '150 km²',
  compass_quartz_desc: "Notre licence de quartz couvre 150 km², offrant un immense potentiel pour des applications industrielles et technologiques. Le quartz est un minéral essentiel utilisé dans l'électronique, la fabrication du verre et les panneaux solaires. Compass Resources s'engage à valoriser cette ressource, garantissant un approvisionnement en quartz de haute qualité pour répondre à la demande mondiale croissante.",
  compass_quartz_cta: "Technologie & Électronique",

  compass_copper_title: "Licence Cuivre",
  compass_copper_badge: '471 km²',
  compass_copper_desc: "Notre licence de cuivre s'étend sur 471 km², une région réputée pour ses gisements de cuivre de haute qualité. Le cuivre est indispensable aux infrastructures modernes, aux systèmes d'énergie renouvelable et à l'électronique. Cette licence renforce l'engagement de Compass Resources à soutenir la croissance industrielle mondiale et la transition vers l'énergie verte.",
  compass_copper_cta: "Transition Vers l'Énergie Verte",

  compass_blacksand_title: "Licence Sable Noir",
  compass_blacksand_badge: '41 km²',
  compass_blacksand_desc: "La licence de sable noir couvre une zone ciblée de 41 km², réputée pour sa haute teneur en minéraux, notamment les terres rares et les métaux lourds. Ces ressources sont vitales pour la production de matériaux avancés dans les secteurs aérospatial, électronique et des énergies renouvelables. Compass Resources vise à développer des techniques d'extraction durables pour maximiser le potentiel de cette ressource unique.",
  compass_blacksand_cta: "Terres Rares",

  compass_iron_title: "Licence Minerai de Fer",
  compass_iron_badge: 'Actif Stratégique',
  compass_iron_desc: "Notre licence de minerai de fer représente un actif stratégique dans le paysage minier mauritanien. Le minerai de fer est fondamental pour le développement des infrastructures mondiales et la production d'acier. Avec la réputation établie de la Mauritanie comme grand producteur de minerai de fer, cette licence positionne Compass Resources pour contribuer à la chaîne d'approvisionnement mondiale tout en soutenant le développement économique local.",
  compass_iron_cta: "Développement des Infrastructures",

  compass_inv_title: "Votre Meilleur Partenaire\ndans le Secteur Minier Mauritanien",
  compass_inv_subtitle: "Profitez des opportunités d'investissement qu'offre le secteur minier mauritanien, avec ses abondantes ressources en minerai de fer, or, cuivre, uranium et bien plus encore.",
  compass_inv_card1_title: 'Soutien Gouvernemental',
  compass_inv_card1_desc: "Incitations fiscales et réglementations simplifiées favorisant les investissements étrangers dans le secteur minier",
  compass_inv_card2_title: 'Infrastructure Améliorée',
  compass_inv_card2_desc: "Réseaux de transport et installations portuaires améliorés renforçant l'efficacité opérationnelle",
  compass_inv_card3_title: 'Accès Stratégique',
  compass_inv_card3_desc: "Accès direct aux marchés internationaux avec une demande mondiale croissante en minéraux critiques",
  compass_inv_cta_title: 'Recherche de Partenaires Internationaux',
  compass_inv_cta_desc: "Nous recherchons des partenaires internationaux dotés de l'expertise et des ressources nécessaires pour transformer nos sites d'exploration en opérations minières de classe mondiale.",
  compass_inv_cta1: 'Devenir Partenaire',
  compass_inv_cta2: 'Demander des Informations',

  compass_contact_tag: 'Nous Contacter',
  compass_contact_title: "Discutons de Votre Investissement",
  compass_contact_subtitle: "Contactez Compass Resources pour explorer les opportunités de partenariat dans le secteur minier mauritanien",
  compass_contact_addr_label: 'Adresse',
  compass_contact_phone_label: 'Téléphone',
  compass_contact_email_label: 'Email',
  compass_contact_parent_label: 'Société Mère',
  compass_contact_note: "Compass Resources est une filiale à part entière de GDSATLAS, spécialisée dans l'exploitation minière durable et l'exploration minérale en Mauritanie.",
  compass_form_title: 'Envoyez-nous un message',
  compass_form_name: 'Nom',
  compass_form_name_ph: 'Votre nom',
  compass_form_email: 'Email',
  compass_form_email_ph: 'votre@email.com',
  compass_form_message: 'Message',
  compass_form_message_ph: "Parlez-nous de votre intérêt d'investissement",
  compass_form_submit: 'Envoyer le Message',

  compass_footer_tagline: "Valoriser les richesses minérales de la Mauritanie par une exploration durable et des pratiques minières responsables.",
  compass_footer_subsidiary: 'Filiale à part entière de GDSATLAS Holding',
  compass_footer_back: 'Retour à GDSATLAS Holding',
  compass_footer_links: 'Liens Rapides',
  compass_footer_about: 'À Propos',
  compass_footer_licenses: 'Licences Minières',
  compass_footer_investment: 'Investissement',
  compass_footer_contact: 'Contact',
  compass_footer_copyright: '© 2025 Compass Resources Mauritanie. Une Entreprise GDSATLAS. Tous droits réservés.',
};

export default compassFR;
